import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumns3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconColumns3"><Path d="M8.37988 21H5.5C4.11929 21 3 19.8807 3 18.5V5.5C3 4.11929 4.11929 3 5.5 3H8.37988V21Z" fill="currentColor"/><Path d="M14.6201 3V21H9.37988V3H14.6201Z" fill="currentColor"/><Path d="M18.5 3C19.8807 3 21 4.11929 21 5.5V18.5C21 19.8807 19.8807 21 18.5 21H15.6201V3H18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumns3;
